import { useId } from 'react';
import { Buttons } from 'components';
import * as S from './Pagination.styled';

export const Pagination = ({ openedRows$, gridRef, totalRows$, paginationStep }) => {
  const progressBarId = useId();

  const loadMoreAction = (value) => {
    gridRef.current.api.showLoadingOverlay();
    if (totalRows$.value - openedRows$.value >= value) {
      openedRows$.value = openedRows$.value + value;
    } else {
      openedRows$.value = totalRows$.value;
    }
    gridRef.current.api.hideOverlay();
  };

  return (
    <S.Pagination>
      <Buttons.TertiaryNormal
        id='add_more_event'
        isDisabled={openedRows$.value === totalRows$.value}
        onClick={() => loadMoreAction(paginationStep)}
      >
        Load More
      </Buttons.TertiaryNormal>
      <S.VerticalSeparator />
      <S.Text>
        Showed: <span>{openedRows$.value}</span> of <span>{totalRows$.value.toLocaleString()}</span>
      </S.Text>
      <S.MyProgressBar id={progressBarId} max={totalRows$.value ?? 0} value={openedRows$.value} />
    </S.Pagination>
  );
};
